import React from 'react';
import {
	Container,
	Box,
	Grid,
	Paper,
	Divider,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	Avatar,
	withStyles,
	TableCell,
} from '@material-ui/core';
import TitleText from './TitleText';
import BodyText from './BodyText';
const BankDetails = () => {
	return (
		<>
			<Grid container spacing={4}>
				<Grid item xs={12} md={5} lg={5}>
					<TitleText
						four
						textStyle={{
							fontFamily: 'Josefin Sans, sans-serif',
							fontWeight: 500,
							fontSize: 18,
						}}>
						Bandhan Bank Detail
					</TitleText>
					<Box
						mt={'20px'}
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							Bank Name:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							Bandhan Bank
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							A/c No:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							10180006804947
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							IFSC code:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							BDBL0001821
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							AC/ Holder:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							E WEB BAZAR PVT LTD
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							Branch Address:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							Dhanbad, Jharkhand.
						</BodyText>
					</Box>
				</Grid>
				<Grid item xs={1}></Grid>
				<Grid item xs={12} md={5} lg={5}>
					<TitleText
						four
						textStyle={{
							fontFamily: 'Josefin Sans, sans-serif',
							fontWeight: 500,
							fontSize: 18,
						}}>
						State Bank Detail
					</TitleText>
					<Box
						mt={'20px'}
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							Bank Name:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							State Bank of India
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							A/c No:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							31833159713
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							IFSC code:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							SBIN0001641
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							AC/ Holder:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							RAHUL ARYA
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							Branch Address:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							SM, Dhanbad, Jharkhand.
						</BodyText>
					</Box>
				</Grid>
				<Grid item xs={12} md={5} lg={5}>
					<TitleText
						four
						textStyle={{
							fontFamily: 'Josefin Sans, sans-serif',
							fontWeight: 500,
							fontSize: 18,
						}}>
						UPI Payment
					</TitleText>
					<Box
						mt={'20px'}
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							Paytm:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							7677854855
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							Google Pay:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							7677854855
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							Phone Pay:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							7677854855
						</BodyText>
					</Box>
				</Grid>
				{/* <Grid item xs={4}>
					<Box>
						<TitleText four>UPI Payment</TitleText>
					</Box>
				</Grid>
				<Grid item xs={4}>
					<Box>
						<TitleText four>Axis Bank Detail</TitleText>
					</Box>
				</Grid> */}
			</Grid>
		</>
	);
};

export default BankDetails;
